// ============================================================================
// finRotulos — dicionário FECHADO dos textos do Financeiro (09/10/2026)
// ============================================================================
// Pedido do dono (DIRETRIZ v2 da "Rotina da unidade"): trocar SÓ o jargão
// interno do sistema que ninguém entende — "título" → "conta", mútuo →
// "transferência entre empresas", OFX → "arquivo do extrato", FECHADO /
// AGUARDANDO / EXCEÇÃO → Bateu / Aguardando / Divergente. Os termos
// financeiros normais (Contas a pagar, categoria, centro de custo, dar baixa,
// vincular, competência) ficam.
//   · ROTULOS_ANTIGOS = os literais do HEAD 150c6619, exatamente (um teste
//     garante: com FIN_TRILHO_UNIDADE desligada a tela fica igual);
//   · ROTULOS_NOVOS   = os textos com a flag ligada;
//   · R               = o que as telas usam.
// Lista FECHADA: chave nova entra no fim, com o literal antigo e o novo.
// Funções (semTituloPorque) recebem o tipo da linha ('débito' | 'crédito').
// Sem imports além da flag (finAuditoriaFormat.js importa este arquivo).
// ============================================================================

import { FIN_TRILHO_UNIDADE, FIN_FECHAMENTO_DIA } from '../config/featureFlags.js';

export const ROTULOS_ANTIGOS = Object.freeze({
  esteTitulo: 'É este título',
  vincular: 'É este título',
  vincularEDarBaixa: 'É este título',
  pendenteSemTitulo: 'Pendente: sem título',
  tituloDois: 'Título:',
  nenhumTitulo: 'Nenhum título de mesmo valor perto desta data.',
  semTituloPorque: (tipo = 'débito') => `Este ${tipo} não tem título (registrar o porquê)`,
  lancarMutuo: 'Lançar como mútuo para',
  mutuoRecebido: 'Registrar mútuo recebido de',
  mutuoCurto: 'Mútuo',
  enviarOfx: 'Enviar extrato (OFX)',
  ajudaOfx: 'Baixe o extrato da conta no site ou app da Stone em formato OFX. Mandar o mesmo período de novo não duplica nada.',
  envieOfxAcima: 'Nenhuma linha nesta conta e período. Se o extrato ainda não foi enviado, envie o OFX acima.',
  envieOfxRecebimentos: 'Sem extrato desta conta no período: envie o OFX na aba Extrato Stone para conferir o que caiu.',
  estadoDia: Object.freeze({ fechado: 'FECHADO', aguardando: 'AGUARDANDO', excecao: 'EXCEÇÃO' }),
  kpiExcecoes: 'Exceções',
  rodapeLinhas: '“É este título” só registra o vínculo (não dá baixa nem muda o título). “Lançar em Contas a Pagar” abre o formulário já '
    + 'preenchido (descrição, conta Stone, forma e centro de custo); ao salvar, o débito já fica ligado ao título novo e sai dos pendentes. '
    + 'PIX entre as empresas do grupo: “É este repasse” liga o PIX ao repasse do rateio (mesmo com valor diferente: você escolhe o que '
    + 'fazer com a diferença) e a outra ponta do PIX junto.',
  // acréscimo (RecebimentosTab, legenda da conferência por dia — mesma troca do estadoDia)
  legendaEstadoDia: 'FECHADO = caiu dentro da faixa esperada · AGUARDANDO = ainda não é o dia, falta extrato ou falta uma unidade da conta · EXCEÇÃO = caiu diferente do esperado ·',
  // acréscimos da integração (09/10/2026): os "título" que ainda apareciam com a flag
  preenchaCampos: 'Preencha: título, valor e vencimento',
  extratoLigaAoSalvar: 'Ao salvar, este débito fica ligado ao título e sai dos pendentes.',
  mutuoNaoConferido: 'Não deu para conferir se este mútuo repete um repasse de rateio',
  aplicarParcelas: 'mesmo título/fornecedor',
  situacaoLigado: 'ligado a título',
  situacaoSemTitulo: 'sem título (com motivo)',
  titulosLigados: 'Títulos ligados (Contas a Pagar)',
  titulosCitados: 'título(s) citados no alerta não foram encontrados (cancelados ou fora da lista).',
  nenhumTituloLigado: 'Nenhum título ligado.',
});

export const ROTULOS_NOVOS = Object.freeze({
  esteTitulo: 'Vincular',
  vincular: 'Vincular',
  vincularEDarBaixa: 'Vincular e dar baixa',
  pendenteSemTitulo: 'Pendente: sem conta lançada',
  tituloDois: 'Conta:',
  nenhumTitulo: 'Nenhuma conta de mesmo valor perto desta data.',
  semTituloPorque: (tipo = 'débito') => `Este ${tipo} não tem conta lançada (registrar o porquê)`,
  lancarMutuo: 'Lançar como transferência entre empresas para',
  mutuoRecebido: 'Registrar transferência recebida de',
  mutuoCurto: 'Transferência entre empresas',
  enviarOfx: 'Enviar arquivo do extrato',
  ajudaOfx: 'Baixe o arquivo do extrato da conta no site ou app da Stone (opção OFX). Mandar o mesmo período de novo não duplica nada.',
  envieOfxAcima: 'Nenhuma linha nesta conta e período. Se o extrato ainda não foi enviado, envie o arquivo do extrato acima.',
  envieOfxRecebimentos: 'Sem extrato desta conta no período: envie o arquivo do extrato na aba Extrato Stone para conferir o que caiu.',
  estadoDia: Object.freeze({ fechado: 'Bateu', aguardando: 'Aguardando', excecao: 'Divergente' }),
  kpiExcecoes: 'Divergentes',
  rodapeLinhas: '“Vincular e dar baixa” liga o débito à conta e a marca como paga na data do banco; “Vincular” só liga. “Lançar em Contas '
    + 'a Pagar” abre o formulário já preenchido (descrição, conta Stone, forma e centro de custo); ao salvar, o débito fica ligado à conta '
    + 'nova e sai dos pendentes. PIX entre as empresas do grupo: “É este repasse” liga o PIX ao repasse do rateio e a outra ponta junto.',
  legendaEstadoDia: 'Bateu = caiu dentro da faixa esperada · Aguardando = ainda não é o dia, falta extrato ou falta uma unidade da conta · Divergente = caiu diferente do esperado ·',
  preenchaCampos: 'Preencha: descrição, valor e vencimento',
  extratoLigaAoSalvar: 'Ao salvar, este débito fica ligado à conta e sai dos pendentes.',
  mutuoNaoConferido: 'Não deu para conferir se esta transferência entre empresas repete um repasse de rateio',
  aplicarParcelas: 'mesma descrição/fornecedor',
  situacaoLigado: 'ligado a uma conta',
  situacaoSemTitulo: 'sem conta (com motivo)',
  titulosLigados: 'Contas ligadas (Contas a Pagar)',
  titulosCitados: 'conta(s) citadas no alerta não foram encontradas (canceladas ou fora da lista).',
  nenhumTituloLigado: 'Nenhuma conta ligada.',
});

/** Os textos que a tela usa (flag ligada → novos; desligada → os do HEAD). */
export const R = FIN_TRILHO_UNIDADE ? ROTULOS_NOVOS : ROTULOS_ANTIGOS;

export default R;

// ─── Fechamento do dia (12/10/2026, atrás de FIN_FECHAMENTO_DIA) ───────────
// "Em Moema a gente faturou quase 140k e nas entradas está mostrando 91k": o
// primeiro número da agenda de recebíveis é o CARTÃO pelo dia em que a Stone
// deposita, não o faturamento. Dicionário à parte (outra flag), com a mesma
// regra: ANTIGOS = os literais do HEAD 156ecf62; NOVOS = com a flag; chaves
// iguais nos dois.
export const ROTULOS_FECHAMENTO_ANTIGOS = Object.freeze({
  kpiCartao: 'Vendido no cartão',
  caiuNaContaTitulo: 'Crédito de cartão + PIX que entrou no extrato da Stone NESTE dia (o cartão cai no dia útil seguinte à venda)',
});
export const ROTULOS_FECHAMENTO_NOVOS = Object.freeze({
  kpiCartao: 'Cartão a cair no período',
  caiuNaContaTitulo: 'O depósito da Stone que leva o cartão vendido neste dia (D+1 útil; sexta, sábado e feriado caem juntos) e os PIX do dia',
});
/** Os textos do fechamento que a tela usa (flag ligada → novos; desligada → os do HEAD). */
export const RF = FIN_FECHAMENTO_DIA ? ROTULOS_FECHAMENTO_NOVOS : ROTULOS_FECHAMENTO_ANTIGOS;

// ─── "Como da última vez" (17/10/2026, atrás de FIN_ULTIMA_VEZ) ────────────
// "o sistema deve reconhecer as contas já categorizadas para não precisar ficar
// lançando o que foi toda vez". Textos NOVOS (não existiam antes: com a flag
// desligada nenhum aparece, as telas é que conferem a flag). Sem travessão e sem
// jargão ("conta", nunca "título"; nada de custo_de, mútuo ou OFX).
export const ROTULOS_ULTIMA_VEZ = Object.freeze({
  como: 'Como da última vez',
  lancar: 'Lançar como da última vez',
  comoEm: (dia, categoria) => `Como em ${dia}: ${categoria}`,
  antes: (dia) => `Antes, em ${dia}`,
  vezes: (n) => `${n}× com este fornecedor`,
  nomeParecido: 'nome parecido',
  intermediario: 'pago por intermediário (o banco não mostra a loja): confira',
  rateioIgual: (quem) => `rateio igual entre ${quem}`,
  rateioPct: (quem) => `rateio em porcentagem entre ${quem}`,
  rateioValor: (quem) => `rateio por valor entre ${quem} (abre como igual)`,
  todasUnidades: (n) => `as ${n} unidades`,
  custoDe: (nome) => `custo de ${nome}`,
  custoRede: 'custo da rede',
  lancarIguais: (n, total) => `Lançar os ${n} iguais (${total})`,
  confirmarIguais: (n, categoria, total) => `Lançar ${n} contas de ${categoria} (${total}), pagas na data de cada débito e vinculadas a ele?`,
  okIguais: (n) => `${n} ${n === 1 ? 'conta lançada como da última vez (paga e vinculada)' : 'contas lançadas como da última vez (pagas e vinculadas)'}.`,
  jaExistiam: (n) => ` ${n} já estava${n === 1 ? '' : 'm'} lançada${n === 1 ? '' : 's'} (nada em dobro).`,
  falhasIguais: (n, lista) => `Não ${n === 1 ? 'foi lançada' : 'foram lançadas'} (continuam pendentes): ${lista}.`,
  preenchido: (dia, conta) => `Preenchido como a conta de ${dia}${conta ? ` (${conta})` : ''}: confira e salve.`,
  avisoPorValor: 'Da última vez o rateio foi por valor: aqui ele abre como igual. Confira a divisão.',
  avisoSemDetalhe: 'Confira a divisão do rateio.',
  competencia: (comp) => `Competência ${comp}, como nas duas últimas vezes.`,
  // 17/10/2026 (revisão): "do extrato" diz onde achar a linha
  rastro: (dia, linhaId) => `Preenchido como a conta de ${dia}${linhaId ? ` (linha #${linhaId} do extrato)` : ''}.`,
  loteObservacao: 'Lançado pelo extrato (iguais em lote).',
  daUltimaVez: (dia, conta) => `Da última vez (${dia}${conta ? ` · ${conta}` : ''})`,
  antesNovaConta: (dia, conta) => `Antes (${dia}${conta ? ` · ${conta}` : ''})`,
  ultimoValor: (v) => `último valor ${v}`,
  usar: 'Usar',
  naoCarregou: 'Não deu para buscar a última vez deste fornecedor agora.',
  // 17/10/2026 (revisão): o rodapé da lista explica os dois botões novos (só com a flag ligada)
  rodape: '“Lançar como da última vez” abre o mesmo formulário preenchido como a última conta deste fornecedor; '
    + 'só grava quando você salva. “Lançar os N iguais” lança, depois de você confirmar, uma conta para cada débito igual '
    + 'deste fornecedor, paga na data do débito e vinculada a ele.',
});
/** Os textos do "Como da última vez" que a tela usa (a flag fica nas telas). */
export const RU = ROTULOS_ULTIMA_VEZ;

// ─── Extrato sem duplicidade (22/10/2026, atrás de FIN_JA_LANCADA, FIN_TRAVA_DUPLICIDADE,
// FIN_ANTES_DA_ROTINA e FIN_EXTRATO_CONTA_CERTA) ──────────────────────────────
// "o sistema não pode ficar pedindo para categorizar nas rotinas do financeiro e extrato o que já foi
// categorizado". Textos NOVOS (com as flags desligadas nenhum aparece). Sem travessão e sem jargão.
export const ROTULOS_DUPLICIDADE = Object.freeze({
  jaLancada: (titulo) => `Já lançada em Contas a Pagar: ${titulo || '(sem descrição)'}`,
  // revisão 1 (22/10/2026): a conta igual sem o nome do favorecido e sem pagamento no mesmo dia
  possivel: (titulo) => `Possível conta já lançada: ${titulo || '(sem descrição)'}`,
  semNome: 'o nome não bate com o favorecido: confira antes de vincular',
  lancarMesmoAssim: 'É outra despesa? Lançar mesmo assim',
  varias: (n) => `${n} contas iguais já lançadas em Contas a Pagar: escolha a certa (o sistema não escolhe sozinho).`,
  tambemOutra: 'esta conta também bate com outra saída',
  pagaEm: (dia) => `paga em ${dia}`,
  venceEm: (dia) => `vence ${dia}`,
  peloValorPago: 'pelo valor pago',
  badgeVincular: 'Pendente: a conta já está lançada, falta vincular',
  vincular: 'Vincular',
  vincularTodas: (n) => `Vincular todas as que só têm uma conta igual (${n})`,
  confirmarTodas: (n, baixas) => `Vincular ${n} ${n === 1 ? 'saída' : 'saídas'} à conta igual que já está em Contas a Pagar?`
    + (baixas ? ` ${baixas} ainda não ${baixas === 1 ? 'está paga e fica paga' : 'estão pagas e ficam pagas'} na data do banco.` : ''),
  okTodas: (n) => `${n} ${n === 1 ? 'saída vinculada à conta que já estava lançada' : 'saídas vinculadas às contas que já estavam lançadas'}.`,
  falhasTodas: (n, lista) => `Não ${n === 1 ? 'foi vinculada' : 'foram vinculadas'} (continuam pendentes): ${lista}.`,
  // revisão 1 (22/10/2026): sem "fica na Auditoria" (lá não há nada delas: o único lugar é o "Ver")
  antesDaRotina: (n, dia) => `${n} ${n === 1 ? 'saída' : 'saídas'} de antes de ${dia} ${n === 1 ? 'está' : 'estão'} fora da rotina:`,
  verAntes: 'Ver',
  mostrandoAntes: (dia) => `Mostrando as saídas pendentes de antes de ${dia} (fora da rotina).`,
  voltarAntes: 'Voltar',
  badgeAntes: (dia) => `De antes de ${dia}: fora da rotina`,
  contaIgualTitulo: 'Esta saída já tem conta lançada em Contas a Pagar. Vincule a conta certa em vez de lançar de novo:',
  outraDespesa: 'É outra despesa com o mesmo valor: lançar mesmo assim',
  motivoOutraDespesa: 'Ex.: é outra despesa com o mesmo valor',
  // revisão 1 (22/10/2026): quem faz a rotina também passa, com o motivo (o servidor manda pode_passar); se não puder:
  soDonoPassa: 'Para lançar mesmo assim, peça ao dono ou crie a conta em Contas a Pagar e depois use Vincular aqui.',
  vinculadaSemBaixa: 'A saída foi vinculada, mas a conta não foi marcada como paga: dê a baixa em Contas a Pagar',
  avisoParecida: (valor, fornecedor, titulo, dia) => `Já existe conta de ${valor} de ${fornecedor} neste mês: ${titulo} (${dia}). Confira se não é a mesma.`,
  avisoDebito: (valor, dia) => `O extrato tem um débito de ${valor} em ${dia} já ligado a outra conta. Confira se não é a mesma despesa.`,
  confirmarContaDono: 'Sim, é desta conta (com o motivo)',
  motivoConta: 'Ex.: o arquivo veio sem o número da conta e eu conferi que é desta',
  rotinaVincular: (n) => `${n} ${n === 1 ? 'saída já tem a conta lançada' : 'saídas já têm a conta lançada'} em Contas a Pagar: não é preciso lançar de novo, só vincular.`,
});
/** Os textos do extrato sem duplicidade que a tela usa (as flags ficam nas telas). */
export const RD = ROTULOS_DUPLICIDADE;
